import { stdObject } from "../../../../data/types/stdObject";

export const cashTotalsFunc = ({ t, salesSection }: stdObject) => {
  return "header" in salesSection
    ? salesSection.results?.totals?.TPA0
      ? [
          {
            NOMCAJ: t("p.invoicedAmount"),
            TOT: salesSection.results.totals.TPA0,
          },
          ...salesSection.results.cash,
        ]
      : salesSection.results.cash
    : [];
};
